import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  OnChanges,
  PipeTransform,
  Pipe,
  Inject,
  Optional
} from '@angular/core';
import {ApiRestService} from "../../_service/api-rest.service";
import {ToastrService} from "ngx-toastr";
import {Persona} from "../../models/persona";
import {TranslateService} from "@ngx-translate/core";
import {ImportReferentiComponent} from "../../import-Referenti/import-referenti.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { environment } from 'src/environments/environment';
import {ApiPathsService} from "../../../api-paths.service";
import {IDropdownSettings} from "../../../../LibrerieCustom/MultiselectDropdown";
import { Router } from '@angular/router';
import { DynamicEditComponent } from 'src/app/shared/dynamic-edit/dynamic-edit.component';
import { DynamicCrudService } from 'src/app/shared/_services/dynamic-crud.service';

@Component({
  selector: 'app-referenti',
  templateUrl: './referenti.component.html',

})
export class ReferentiComponent implements OnInit, OnChanges {
  @Input() Lista: Persona[];
  @Output() ListaChange = new EventEmitter<Persona[]>();
  @Output() Refresh = new EventEmitter()
  @Input() Cliente: number;
  @Input() noCall: boolean = false;
  environment = environment;
  SelectAll: boolean = false
  reparti: any;
  mansioni: any[];
  dropSetting: IDropdownSettings= { singleSelection: true, singleOutput: true, idField: 'id', textField: 'label',  allowSearchFilter: true, }
  dropMansioneSetting: IDropdownSettings = { singleSelection: false, singleOutput: false, idField: 'id', textField: 'denominazione', allowSearchFilter: true, }
  DropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'denominazione',
    allowRemoteDataSearch: false,
    allowSearchFilter: true,
    searchPlaceholderText: "cerca",
  };
  sedi: any[];
  @Input() filter: any = {};
  @Input() HideReparti: boolean = false;
  @Input() Title: string = "";
  persone: Persona[] = [];
  persona: Persona = new Persona();
  relations: any[] = [
    { id: 'P', label: 'Papà' },
    { id: 'M', label: 'Mamma' },
    { id: 'B', label: 'Baby Sitter' },
    { id: 'NA', label: 'Nonna' },
    { id: 'NO', label: 'Nonno' },
    { id: 'ZO', label: 'Zio' },
    { id: 'ZA', label: 'Zia' },
    { id: 'C', label: 'Cugino' },
  ];
  relation: any;


  constructor (
    @Optional() @Inject('Cliente') public cliente: number,
    @Optional() @Inject('Lista') public lista: Persona[],
    private apirest: ApiRestService,
    private apiPaths: ApiPathsService,
    private toastService: ToastrService,
    public translate : TranslateService,
    private modalService: NgbModal,
    private router: Router,
    private crudService: DynamicCrudService,
  ) {
    this.Cliente = cliente ?? this.Cliente;
    this.Lista = lista ?? this.Lista;
    console.log(this.Lista);
    console.log(this.Cliente);
  }

  ngOnInit(): void {
    this.Lista = this.Lista?.map(x => {
      x.isSelected = false;
      x.oraEntrata = x.oraEntrata ?? '00:00';
      x.oraUscita = x.oraUscita ?? '23:59';
      x['mansioniObject'] = x['mansioniObject']?.map(y => {
        y.id = y.mansioneObject?.id;
        y.denominazione = y.mansioneObject?.label;
        return y;
      })
      return x
    })
    if (this.environment.ClientiAddOn['referentiFromPersone']) {
      this.apiPaths.ClassicPost('/anagrafica/persone/list', { page:0, size:200 }).subscribe(data => {
        this.persone = data.data;
      })
    }
    if(this.environment.ClientiAddOn['repartoReferente']){
      this.apiPaths.ClassicGet('/anagrafica/clienti/referenti/reparti').subscribe(data=>{
        this.reparti = data;
      });
    }
    if (this.environment.ClientiAddOn['sediReferente']) {
      this.apiPaths.ClassicPost('/anagrafica/clienti/referenti/sedi', { id: this.Cliente}).subscribe(data => {
        this.sedi = data;
      })
    }
    if (this.environment.Modules['mansioni']) {
      this.apiPaths.ClassicPost('/anagrafica/clienti/mansione/list', {page:1, size:200}).subscribe(data => {
        this.mansioni = data.data;
      })
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Lista'] && changes['Lista'].currentValue != changes['Lista'].previousValue && this.Lista.some(x => x['mansioniObject']?.some(y => !y.denominazione)))
      this.Lista = this.Lista.map(x => {
        x.isSelected = false;
        x['mansioniObject'] = x['mansioniObject']?.map(y => {
          y.id = y.mansioneObject?.id;
          y.denominazione = y.mansioneObject?.label;
          return y;
        })
        return x
      })
  }


  Relation(item) {
    return this.relations.find(x => x.id == item.relazione.relazione)?.label
}

  Import() {
    let modale = this.modalService.open(ImportReferentiComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<ImportReferentiComponent>modale.componentInstance).Cliente = this.Cliente;
    (<ImportReferentiComponent>modale.componentInstance).Uploaded.subscribe(data=> {
      modale.dismiss();
      this.Refresh.emit();
    });
  }
  // Refresh(){
  //   // this.apirest.getreferenti({id: this.Cliente}).subscribe(data=>{
  //   //   this.Lista = data.data;
  //   // })
  // }
  add() {
    if (this.environment.ClientiAddOn['referentiFromPersone']) {
      this.apiPaths.ClassicPost('/anagrafica/clienti/referenti/associate', { cliente: this.Cliente, persona: this.persona?.id, relazione: this.relation?.id }).subscribe(data => {
       if(this.noCall) return;
        this.Refresh.emit();
      })
      return
    }

    if(!this.Lista)
      this.Lista = [];
    this.Lista.push({ InModifica: true, nome: "", cognome: "", telefono: "", email: "", cliente: this.Cliente, principale: !(this.Lista?.length > 0), repartoObject: this.filter.reparti?.length == 1 ? this.filter.reparti[0] : null, reparto: this.filter.reparti?.length == 1 ? this.filter.reparti[0].id : null, oraEntrata: "00:00", oraUscita: "23:59" });
    this.ListaChange.emit(this.Lista);
  }

  edit(item: Persona) {
    if(item.InModifica ){
      if(!item.nome || item.nome == "" || !item.cognome || item.cognome == ""  )
        this.toastService.warning(this.translate.instant('Messages.InsCampi'));
      else {
        item.InModifica = !item.InModifica;
        item.reparto = item.repartoObject?.id
        item['mansioni'] = item['mansioniObject']?.map(x=>{return{mansione: x.id, data:'2021-01-01'}})
        if(item.id)
          this.apirest.updatereferente(item).subscribe(() => {
            if(this.noCall) return;
            this.Refresh.emit()
          });
        else
          this.apirest.addreferente(item).subscribe((ref)=> {
            item.id = ref.id;
            if(this.noCall) return;
            this.Refresh.emit();

          });
      }
    }else {
        item.InModifica = true;
    }

  }

  delete(co: any) {
    if (this.environment.ClientiAddOn['referentiFromPersone']) {
      this.apiPaths.ClassicPost('/anagrafica/clienti/referenti/deassociate', { cliente: this.Cliente, persona: co?.id}).subscribe(data => {
        this.Refresh.emit();
      })
      return
    }
    if(!confirm(this.translate.instant('Messages.deletemex')))
      return;
    if(co.modifica)
      this.Refresh.emit()
    else if(co.id)
      this.apirest.deletereferente(co).subscribe(()=>{
        this.Refresh.emit();
      });
    else {
      const idx: number = this.Lista.findIndex(x => x == co);
      if (idx > -1)
        this.Lista.splice(idx, 1);
    }

  }

  SelectedRef() {
    return this.Lista?.filter(x=>x.isSelected)?.map(x=>x.id) ?? [];
  }
  DropSettings = (labelParam: string = 'label'): IDropdownSettings => {
    return {
      singleSelection: false,
      closeDropDownOnSelection: false,
      idField: 'id',
      textField: labelParam,
      allowRemoteDataSearch: false,
      allowSearchFilter: true,
      searchPlaceholderText: "cerca",
    }
  }

  InviaCred() {
    this.apiPaths.ClassicPost('/anagrafica/clienti/referenti/email', {ids: this.SelectedRef()}).subscribe(()=>{
      this.toastService.success("Email Inviate con successo!");
    })
  }
  AggiungiFabbisogno(persona_id: number) {
    if (!this.environment.Modules['FabbisognoFormativo']) return;

    const EditModal = this.modalService.open(DynamicEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
    (<DynamicEditComponent>EditModal.componentInstance).CrudSettings = this.crudService.GetCrudSettings('fabbisogno');
    (<DynamicEditComponent>EditModal.componentInstance).Item = { persona_id: persona_id };//Object.assign({}, this.CrudSettings.AddDefaultObject ?? {}, this.ConcatParams);
    (<DynamicEditComponent>EditModal.componentInstance).ExternalAdd = true;
    (<DynamicEditComponent>EditModal.componentInstance).updated.subscribe(data => {
      this.SelectedRef().forEach(ref => {
        data.persona_id = ref;
        this.apiPaths.ClassicPost('/anagrafica/clienti/fabbisogno/add', data).subscribe();
      })
    });
  }
  AggiungiFabbisogni() {
    if (!this.environment.Modules['FabbisognoFormativo']) return;
    if (!this.SelectedRef().length) {
      this.toastService.warning(`Selezionare almeno un ${this.translate.instant('cliente.sezioni.referenti')} per effettuare questa operazione.`);
      return;
    }
    const EditModal = this.modalService.open(DynamicEditComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
    (<DynamicEditComponent>EditModal.componentInstance).CrudSettings = this.crudService.GetCrudSettings('fabbisogno');
    (<DynamicEditComponent>EditModal.componentInstance).Item = { fromLavoratoriList: true };//Object.assign({}, this.CrudSettings.AddDefaultObject ?? {}, this.ConcatParams);
    (<DynamicEditComponent>EditModal.componentInstance).ExternalAdd = true;
    (<DynamicEditComponent>EditModal.componentInstance).updated.subscribe(data => {
      this.SelectedRef().forEach(ref => {
        data.persona_id = ref;
        this.apiPaths.ClassicPost('/anagrafica/clienti/fabbisogno/add', data).subscribe();
      })
    });
  }
  open(item){
    var url = `/listautenti/referente/${item.id}`;
    this.router.navigate([url]);
  }
  checkUncheckAll() {
    this.Lista.forEach(persona=>{
      persona.isSelected = this.SelectAll;
    })
  }

  isAllSelected() {
    this.SelectAll = this.Lista.every(function (item: any) {
      return item.isSelected == true;
    })
  }
}
@Pipe({
  name: 'PipeReferenti',
  pure: false
})
export class PipeReferenti implements PipeTransform {
  transform(items: any[], filter: {mansioni: any [], reparti: any [], cerca: string, sedi: any[]}): any {
    if (!items || !filter)
      return items;
    return items.filter(item =>
      (!filter?.cerca?.length || (`${item.nome}${item.cognome}${item.cognome}${item.nome}${item.telefono}${item.email}`.toLocaleLowerCase().replace(/\s/g, "")).includes(filter.cerca?.toLocaleLowerCase().replace(/\s/g, ""))) &&
      (!filter?.mansioni?.length || item.mansioniObject?.find(mansione => filter.mansioni.find(x => mansione?.mansioneObject.id == x.id))) &&
      (!filter?.sedi?.length || item.sediObject?.find(sede => filter.sedi.find(x => sede?.id == x.id))) &&
      (!filter?.reparti?.length || filter.reparti.find(x => x.id == item.reparto))
    );
  }
}

